import { VerticalFlexbox } from "@src/shared/components/layout/Flexbox";

import { VisitsListV2 } from "../../../components/v2/VisitsList";

export function VisitsPageV2() {
  return (
    <VerticalFlexbox className="mx-auto min-h-full w-full max-w-[860px] bg-background">
      <VisitsListV2 />
    </VerticalFlexbox>
  );
}
